module.exports = __webpack_public_path__ + "img/us-tx.13ccaaad.svg";